const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const browser = require("detect-browser").detect();
const createReactClass = require("create-react-class");
const RangeSlider = require("../core/view/RangeSlider");
const LoadingCircle = require("../core/view/LoadingCircle");
const Tooltip = require("../core/view/Tooltip");
const WonkyButton = require("../core/view/WonkyButton");
const IconButton = require("../core/view/IconButton");
const AssetsUtil = require("../core/util/AssetsUtil");
const CopyTable = require("../core/util/CopyTable");
const Sounds = require("../core/util/Sounds");
const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");
const AT = require("../core/vault/ActionTypes");
const OpsUser = require("../core/vault/OpsUser");
const BlockButton = require("../trainer/reactView/BlockButton");
const {TransitionGroup, CSSTransition} = require("react-transition-group");
const {
	DEFAULT_THEATER_VOLUME,
	ALLOWED_MOBILE_BROWSERS,
} = require("../../shared/Constants");
const TrainerCore = require("../../shared/TrainerCore");
const ErrorMessage = require("../core/view/ErrorMessage");
const PlaybackSpeedButton = require("./PlaybackSpeedButton");

const ReactPlayerWrapper = require("./ReactPlayerWrapper");
const screenfull = require("screenfull");

const THROTTLE_MS = 2000;

const styles = require("./styles/TheaterPlayer.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "TheaterPlayer",

		propTypes: {
			user: PT.object,
			gradeNumber: PT.number,
			videoSetID: PT.number.isRequired,
			blockID: PT.number,
			chapterID: PT.number,
			videoIndex: PT.number.isRequired,
			videoURL: PT.string.isRequired,
			headerText: PT.string,
			captionsPath: PT.string,
			nextVideoThumbnailLink: PT.string,
			onWatchNextVideo: PT.func,
			onPlayLesson: PT.func,
			position: PT.number,
			trainerBlock: PT.object,
			hasNoBackground: PT.bool,
			demo: PT.bool,
			chapter: PT.object,
			videoIntervention: PT.bool,
			skipLogging: PT.bool,
			disableFullScreen: PT.bool,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			openedModalOnPage: function() {
				this.setState({isPlaying: false, canPlayByKeypress: false});
			},
			closedModalOnPage: function() {
				this.setState({
					isPlaying: !this.state.videoHasEnded,
					canPlayByKeypress: true,
				});
			},
			clearVideoIntervention: function(startPlaying) {
				if (startPlaying) {
					this.setState({isPlaying: true, videoHasEnded: false});
				}
			},
		},

		getInitialState: function() {
			const user = this.props.user;
			this.debouncedDispatch = _.debounce(this.props.dispatch, 500);
			return {
				isPlaying: false,
				isActive: true,
				theaterVolume: OpsUser.getTheaterVolume(user),
				theaterSoundEnabled: OpsUser.getTheaterSoundEnabled(user),
				played: 0,
				duration: 0,
				theaterCaptionsOn: false,
				isFullScreen: false,
				videoHasEnded: false,
				isLoaded: false,
				canPlayByKeypress: true,
				playbackRate: OpsUser.getTheaterPlaybackRate(user),
			};
		},

		componentDidMount: function() {
			const user = this.props.user;
			this.throttledUpdatePosition = _.throttle(
				this.updatePosition,
				THROTTLE_MS
			);
			this.activityInterval = setInterval(() => this.checkActivity(), 300);
			if (screenfull.enabled) {
				screenfull.on("change", this.onFullscreenChange);
			}
			document.addEventListener("keydown", this.handleKeyDown);
			// Browsers as a default hide captions tracks if they're there on page load.
			// To get around this, we always disable captions on the first render,
			// then immediately re-render with them.
			if (OpsUser.getTheaterCaptionsOn(user)) {
				this.captionsTimeout = setTimeout(
					() => this.setState({theaterCaptionsOn: true}),
					1000
				);
			}
		},

		// Destroy HLS player associated with current video, freeing up memory.
		// We do this to avoid a memory leak.
		// We also destroy the video element, which is necessary when switching
		// videos to make sure captions update, since the old captions track element
		// will stick around otherwise, causing weirdness (https://bugs.aops.com/T60940).
		// See https://github.com/video-dev/hls.js/issues/2198 for more data on why
		// HLS is bad at cleaning up its text tracks.
		destroyCurrentHLSPlayer: function() {
			const hlsPlayer = this.player && this.player.getInternalPlayer("hls");
			if (hlsPlayer) {
				hlsPlayer.destroy();
			}
			const videoEl = this.playerAndControls.querySelector("video");
			if (videoEl) {
				videoEl.remove();
			}
		},

		UNSAFE_componentWillUpdate: function(nextProps) {
			if (nextProps.videoIndex !== this.props.videoIndex) {
				// We cancel any impending position updates when switching videos.
				// Without this, a position update from a previous video could fire after the new video is
				// already playing, setting the position of the new video to the position of the old video.
				this.throttledUpdatePosition.cancel();

				this.video = null;
				this.destroyCurrentHLSPlayer();
				this.setState({
					videoHasEnded: false,
					isLoaded: false,
				});
			}
		},

		componentWillUnmount: function() {
			//Flush any pending updates
			this.debouncedDispatch.flush();
			this.unmounted = true;
			this.throttledUpdatePosition.cancel();
			if (!this.props.skipLogging) {
				this.props.dispatch({
					type: AT.VIDEO_PLAY_PAUSE,
					isPlaying: false,
				});
			}
			if (this.activityInterval) {
				clearInterval(this.activityInterval);
			}
			if (this.inactivityTimeout) {
				clearTimeout(this.inactivityTimeout);
			}
			if (this.captionsTimeout) {
				clearTimeout(this.captionsTimeout);
			}
			if (screenfull.enabled) {
				screenfull.off("change", this.onFullscreenChange);
			}

			this.destroyCurrentHLSPlayer();
			document.removeEventListener("keydown", this.handleKeyDown);
		},

		updatePosition: function(position) {
			if (this.props.skipLogging || !this.props.videoSetID) return;
			this.props.dispatch({
				type: AT.UPDATE_VIDEO_POSITION,
				position,
				videoSetID: this.props.videoSetID,
				chapterID: this.props.chapterID,
				blockID: this.props.blockID,
				videoIndex: this.props.videoIndex,
			});
		},

		updateSettings: function(updateData) {
			updateData.type = this.props.demo
				? AT.UPDATE_TEMP_USER_SETTINGS
				: AT.UPDATE_USER_SETTINGS;
			this.debouncedDispatch(updateData);
			this.setState(updateData);
		},

		checkActivity: function() {
			if (this.unmounted) return;
			if (this.justMovedMouse) {
				this.justMovedMouse = false;
				if (!this.state.isActive) {
					this.setState({isActive: true});
				}
				if (this.inactivityTimeout) {
					clearTimeout(this.inactivityTimeout);
				}

				this.inactivityTimeout = setTimeout(() => {
					if (!this.justMovedMouse && !this.mouseIsDown) {
						this.setState({isActive: false});
					}
				}, 2000);
			}
		},

		onPlayerMouseMove: function() {
			this.justMovedMouse = true;
		},
		// Need to keep track of this so we don't make the controls
		// inactive when the use is holding their mouse down on them but not moving.
		onPlayerMouseDown: function() {
			this.mouseIsDown = true;
		},

		onPlayerMouseUp: function() {
			this.mouseIsDown = false;
		},

		// Formats a number of seconds as ${minutes}:${seconds}
		formatSeconds: function(seconds) {
			const minutes = Math.floor(seconds / 60);
			seconds = Math.floor(seconds % 60);
			const leadingZero = seconds < 10 ? "0" : "";
			return `${minutes}:${leadingZero}${seconds}`;
		},

		playPause: function() {
			this.setState({
				isPlaying: !this.state.isPlaying,
				videoHasEnded: false,
			});
		},

		replay: function() {
			if (this.player) {
				this.setState({
					played: 0,
					isPlaying: true,
					videoHasEnded: false,
				});
				this.player.seekTo(0);
			}
		},

		onSeekMouseDown: function() {
			this.onPlayerMouseDown();
			this.isSeeking = true;
			this.setState({
				videoHasEnded: false,
			});
		},

		onSeekChange: function(value) {
			this.setState({played: value});
		},

		onSeekMouseUp: function(event) {
			this.isSeeking = false;
			this.onPlayerMouseUp();
			this.reseekPlayer();
		},

		// Causes the video player to reseek to the position currently
		// dictated by "played" in state.
		reseekPlayer: function() {
			const {played, duration} = this.state;

			// ReactPlayer has a bug where if you seekTo the end of the video
			// it will start looping from the beginning again. We avoid this
			// because we set the video as not playing if they're at the end,
			// and the play button becomes a replay button that always takes
			// them back to the beginning.
			const seekValue = played === 1 ? duration : played * duration;

			let newState = {
				isLoaded: true,
			};
			if (played === 1) {
				newState = _.extend(newState, {
					isPlaying: played !== 1,
					videoHasEnded: played === 1,
				});
			}
			this.setState(newState);
			// Note that this will not trigger ReactPlayer's onSeek function
			// if seekValue is at the end of the video or past it.
			this.player && this.player.seekTo(seekValue);
		},

		onDuration: function(duration) {
			const {position, videoIntervention} = this.props;

			// Ensures that switching from one video to another makes it autoplay.
			this.setState({
				played: position,
				duration,
				isPlaying: videoIntervention ? false : position !== 1,
				videoHasEnded: position === 1,
			});

			// Seek to video's correct position once duration is loaded.
			// This happens even when switching between videos.
			this.reseekPlayer();
		},

		// Fires when calling the play method on a video causes an error.
		// Importantly, a NotAllowedError happens when videos are stopped from auto-playing because
		// the browser did not get a user gesture. We make sure that the video appears paused
		// if that's the case.
		onError: function(error) {
			if (_.get(error, "name") === "NotAllowedError") {
				this.setState({
					isPlaying: false,
				});
			}
		},

		onProgress: function(state) {
			if (!this.isSeeking) {
				const played = _.round(state.played, 3);
				this.setState({played});
				if (this.seekSlider) {
					this.seekSlider.setValue(played);
				}
				this.throttledUpdatePosition(played);
			}
		},

		onClickFullscreen: function() {
			if (screenfull.enabled) {
				screenfull.toggle(this.playerAndControls);
			}
		},

		onFullscreenChange: function() {
			if (screenfull.enabled) {
				this.setState({isFullScreen: screenfull.isFullscreen});
			}
		},

		setVolume: function(value) {
			const updates = {theaterVolume: parseFloat(value)};
			if (value) {
				updates.theaterSoundEnabled = true;
			}
			this.updateSettings(updates);
			this.setState(updates);
		},

		onPlay: function() {
			if (this.props.videoIntervention) {
				this.props.dispatch({
					type: AT.CLEAR_VIDEO_INTERVENTION,
					play: false,
				});
			}
			if (!this.props.skipLogging) {
				this.props.dispatch({
					type: AT.VIDEO_PLAY_PAUSE,
					isPlaying: true,
				});
			}
		},

		onPause: function() {
			if (!this.props.skipLogging) {
				this.props.dispatch({
					type: AT.VIDEO_PLAY_PAUSE,
					isPlaying: false,
				});
			}
		},

		onEnded: function() {
			this.throttledUpdatePosition(1);
			this.setState({
				isPlaying: false,
				videoHasEnded: true,
				played: 1,
			});
			if (!this.props.skipLogging) {
				this.props.dispatch({
					type: AT.VIDEO_FINISHED,
				});
			}
		},

		onToggleCaptions: function() {
			const updates = {
				theaterCaptionsOn: !this.state.theaterCaptionsOn,
			};
			this.updateSettings(updates);
			this.setState(updates);
		},

		onToggleMuted: function() {
			const {theaterVolume, theaterSoundEnabled} = this.state;
			const updates = {
				theaterSoundEnabled: !theaterSoundEnabled,
			};
			if (this.volumeSlider) {
				if (!theaterVolume) {
					this.volumeSlider.setValue(DEFAULT_THEATER_VOLUME);
					updates.theaterSoundEnabled = true;
					updates.theaterVolume = DEFAULT_THEATER_VOLUME;
				} else if (!theaterSoundEnabled) {
					this.volumeSlider.setValue(theaterVolume);
				} else {
					this.volumeSlider.setValue(0);
				}
			}
			this.updateSettings(updates);
			this.setState(updates);
		},

		getVolumeIconType(theaterSoundEnabled, theaterVolume) {
			if (!theaterSoundEnabled || theaterVolume === 0) {
				return "off";
			}
			if (theaterVolume < 0.34) {
				return "low";
			}
			if (theaterVolume < 0.67) {
				return "medium";
			}
			return "on";
		},

		// Seek by a certain number of seconds
		seekBySeconds: function(seconds) {
			if (!this.player) return;
			const currentTime = this.player.getCurrentTime();
			const newTime = Math.max(
				0,
				Math.min(this.state.duration, currentTime + seconds)
			);

			// Handle end state transitions
			if (this.state.videoHasEnded && newTime < this.state.duration) {
				this.setState({
					videoHasEnded: false,
				});
			}
			// If we're seeking to the end, update videoHasEnded state
			// Use a small buffer (0.1 seconds) to account for floating point precision
			else if (
				!this.state.videoHasEnded &&
				newTime >= this.state.duration - 0.1
			) {
				this.setState({
					videoHasEnded: true,
					isPlaying: false,
				});
			}

			if (this.seekSlider) {
				this.seekSlider.setValue(newTime / this.state.duration);
			}
			this.player.seekTo(newTime, "seconds");
			this.onPlayerMouseMove(); // Keep controls visible
		},

		handleKeyDown(evt) {
			// Keys correspond to spacebar and F8.
			if (
				this.state.canPlayByKeypress &&
				(evt.which === 32 || evt.which === 119)
			) {
				this.playPause();
				evt.preventDefault();
			}
			// Left arrow (37) and right arrow (39) for seeking
			if (this.state.canPlayByKeypress && this.player) {
				if (evt.which === 37) {
					// Left arrow
					this.seekBySeconds(-5);
					evt.preventDefault();
				} else if (evt.which === 39) {
					// Right arrow
					this.seekBySeconds(5);
					evt.preventDefault();
				}
			}
		},

		onWatchNextVideo: function() {
			Sounds.playSound("button-click");
			if (this.props.onWatchNextVideo) {
				this.props.onWatchNextVideo();
			}
		},

		renderNextVideoThumbnail: function() {
			return (
				<div
					className={styles.nextThumbnailContainer}
					onClick={this.onWatchNextVideo}
				>
					<div className={styles.nextThumbnailInner}>
						<span className={styles.nextThumbnailText}>Next Video</span>
						<div className={styles.nextThumbnailImageContainer}>
							<div className={styles.nextThumbnailImageInner}>
								<img
									className={styles.nextThumbnailImage}
									src={this.props.nextVideoThumbnailLink}
								/>
								<img
									className={styles.nextThumbnailPlayButton}
									src={AssetsUtil.getTheaterIcon("play-circle")}
								/>
							</div>
						</div>
					</div>
				</div>
			);
		},

		onPlayLesson: function() {
			Sounds.playSound("lesson-click");
			if (this.props.onPlayLesson) {
				this.props.onPlayLesson();
			}
		},

		renderBlockButton: function() {
			const {
				trainerBlock,
				user,
				onPlayLesson,
				gradeNumber,
				demo,
				chapter,
			} = this.props;
			let containerClass = styles.blockButtonTextContainer;
			if (gradeNumber === 2 || gradeNumber === 3) {
				containerClass += ` ${styles.largerBlockButton}`;
			}

			const requirementLevel = _.get(trainerBlock, "model.requirementLevel");
			const isBonus = TrainerCore.isBonusBlock(requirementLevel);
			const buttonImageSrc = isBonus
				? AssetsUtil.getGeneralIcon("icon-bonus-beast")
				: AssetsUtil.getButton("bell", "white");

			const buttonType = this.state.isFullScreen
				? "theaterplaylessonfullscreen"
				: "theaterplaylesson";

			// Needed by BlockButton
			return _.get(trainerBlock, "model") && onPlayLesson ? (
				<div className={containerClass}>
					<div className={styles.blockButton}>
						<BlockButton
							blockShapeNum={1}
							user={user}
							block={trainerBlock}
							chapter={chapter}
							numUnfinishedBlocks={0}
							isForTheater={true}
							onButtonClick={this.onPlayLesson}
							titleClassName={styles.blockTitleText}
							demo={demo}
						/>
					</div>
					<WonkyButton
						className={styles.playBlueButton}
						buttonImageSrc={buttonImageSrc}
						buttonText={"Play Lesson"}
						buttonType={buttonType}
						handleClick={this.onPlayLesson}
					/>
				</div>
			) : null;
		},

		// Note that all of these ref functions aren't inline in the render function
		// because arrow functions in render produce a performance hit by creating a new function every re-render.
		setPlayerRef: function(ref) {
			this.player = ref;
		},

		setSeekSliderRef: function(ref) {
			this.seekSlider = ref;
		},

		setVolumeSliderRef: function(ref) {
			this.volumeSlider = ref;
		},

		setVideoCaptions: function() {
			if (this.playerAndControls) {
				if (!this.video) {
					// Video element is reset when changing to different video, so we
					// need to set this again after it's been wiped.
					this.video = this.playerAndControls.querySelector("video");
				}
				if (this.video) {
					// Sets both the track child element of the video element and
					// the textTracks property of the video element because of
					// browser implementation differences.
					const tracks = this.video.textTracks;
					const trackInfo = {
						kind: "subtitles",
						srcLang: "en",
						default: true,
						src: this.props.captionsPath,
						mode: this.state.theaterCaptionsOn ? "showing" : "hidden",
					};
					if (tracks.length) {
						tracks[0] = _.extend(tracks[0], {
							src: trackInfo.src,
							mode: trackInfo.mode,
						});
						const trackEl = this.video.getElementsByTagName("track")[0];
						if (trackEl) {
							trackEl.setAttribute("src", trackInfo.src);
							trackEl.setAttribute("mode", trackInfo.mode);
						} else {
							const track = document.createElement("track");
							_.forOwn(trackInfo, (val, key) => track.setAttribute(key, val));
							this.video.appendChild(track);
						}
					} else {
						const track = document.createElement("track");
						_.forOwn(trackInfo, (val, key) => track.setAttribute(key, val));
						this.video.appendChild(track);
						this.video.textTracks[0] = trackInfo;
					}
				}
			}
		},

		onPlayerWrapperTouchStart: function() {
			this.isTouchingPlayerWrapper = true;
		},

		onPlayerWrapperClick: function() {
			if (!this.state.videoHasEnded) {
				if (this.isTouchingPlayerWrapper) {
					if (this.state.isActive) {
						this.playPause();
					} else {
						this.setState({isActive: true});
					}
				} else {
					this.playPause();
				}
			}
			this.isTouchingPlayerWrapper = false;
		},

		onCatchPlayerError: function() {
			this.setState({playerErrorCaught: true});
		},

		onPlaybackRateChange: function(value) {
			this.updateSettings({theaterPlaybackRate: value});
			this.setState({playbackRate: value});
		},

		render: function() {
			const {
				isPlaying,
				theaterVolume,
				theaterSoundEnabled,
				played,
				duration,
				isActive,
				isFullScreen,
				videoHasEnded,
				isLoaded,
			} = this.state;
			const {gradeNumber, disableFullScreen} = this.props;
			const tooltipText = CopyTable.tooltipText;
			const elapsed = duration * played;
			const fadeTransition = {
				enter: styles.fadeIn,
				enterActive: styles.fadeInActive,
				exit: styles.fadeOut,
				exitActive: styles.fadeOutActive,
			};

			const bgAsset = AssetsUtil.getTheaterModalBackground(
				gradeNumber ? "grade-" + gradeNumber : "lab"
			);
			const wonkyBackground = this.props.hasNoBackground ? null : (
				<img className={styles.wonkyBackground} src={bgAsset} />
			);

			const bigPlayButton =
				this.state.isPlaying || videoHasEnded || !isLoaded ? null : (
					<div className={styles.bigPlayButton}>
						<img
							className={styles.bigPlayButtonImage}
							src={AssetsUtil.getTheaterIcon("play-circle")}
						/>
					</div>
				);

			const volumeIconType = this.getVolumeIconType(
				theaterSoundEnabled,
				theaterVolume
			);
			const volumeTooltip = theaterSoundEnabled ? "videoMute" : "videoUnmute";
			const volumeIcon = (
				<Tooltip
					className={styles.volumeButton}
					tooltipText={tooltipText[volumeTooltip]}
					size="small"
					direction="bottom-left"
				>
					<IconButton
						iconImgPath={AssetsUtil.getVolumeIcon(volumeIconType)}
						handleClick={this.onToggleMuted}
					/>
				</Tooltip>
			);

			let playerWrapperClass = styles.playerWrapper;
			let postVideoEl = null;
			let playButtonImage;
			let playButtonHandler;
			let playButtonTooltip;
			if (videoHasEnded) {
				playerWrapperClass += ` ${styles.playerOnFinish}`;
				playButtonImage = AssetsUtil.getTheaterIcon("replay");
				playButtonHandler = this.replay;
				playButtonTooltip = "videoReplay";
				if (this.props.nextVideoThumbnailLink) {
					postVideoEl = this.renderNextVideoThumbnail();
				} else if (this.props.chapter && this.props.gradeNumber) {
					postVideoEl = this.renderBlockButton();
				}
			} else {
				playButtonImage = isPlaying
					? AssetsUtil.getTheaterIcon("pause")
					: AssetsUtil.getTheaterIcon("play-triangle");
				playButtonHandler = this.playPause;
				playButtonTooltip = isPlaying ? "videoPause" : "videoPlay";
			}

			if (!isActive) {
				playerWrapperClass += ` ${styles.inactivePlayer}`;
			}
			if (!isLoaded) {
				playerWrapperClass += ` ${styles.playerWrapperIsLoading}`;
			}

			const playIcon = (
				<Tooltip
					className={styles.playButton}
					tooltipText={tooltipText[playButtonTooltip]}
					size="small"
					direction="bottom-left"
				>
					<IconButton
						iconImgPath={playButtonImage}
						handleClick={playButtonHandler}
					/>
				</Tooltip>
			);

			const captionsImage = this.state.theaterCaptionsOn
				? "turn-cc-off"
				: "turn-cc-on";
			const captionsIconClass = this.props.captionsPath
				? styles.ccButton
				: styles.ccButtonHidden;
			const closedCaptionsIcon = (
				<Tooltip
					className={captionsIconClass}
					tooltipText={tooltipText.videoCaptions}
					size="medium"
					direction="bottom-right"
				>
					<IconButton
						iconImgPath={AssetsUtil.getTheaterIcon(captionsImage)}
						handleClick={this.onToggleCaptions}
					/>
				</Tooltip>
			);

			const fullScreenIconName = isFullScreen
				? "fullscreen-reverse"
				: "fullscreen";
			const fullScreenTooltip = isFullScreen
				? "videoLeaveFullScreen"
				: "videoMakeFullScreen";
			const fullScreenIcon =
				screenfull.enabled && !disableFullScreen ? (
					<Tooltip
						className={styles.fullScreenButton}
						tooltipText={tooltipText[fullScreenTooltip]}
						size="small"
						direction="bottom-right"
					>
						<IconButton
							iconImgPath={AssetsUtil.getTheaterIcon(fullScreenIconName)}
							handleClick={this.onClickFullscreen}
						/>
					</Tooltip>
				) : null;

			this.setVideoCaptions();

			let playerControlsClass = styles.playerControls;
			if (!isLoaded) {
				playerControlsClass += ` ${styles.controlsAreLoading}`;
			}
			// iOS doesn't allow a video's volume to be set via javascript, so we remove
			// the volume slider.
			const volumeSlider =
				browser && _.includes(ALLOWED_MOBILE_BROWSERS, browser.name) ? null : (
					<RangeSlider
						ref={this.setVolumeSliderRef}
						className={styles.volumeSlider}
						value={theaterSoundEnabled ? theaterVolume : 0}
						min={0}
						max={1}
						tooltip={false}
						step={0.01}
						orientation={"horizontal"}
						onChangeStart={this.onPlayerMouseDown}
						onChange={this.setVolume}
						onChangeComplete={this.onPlayerMouseUp}
						handleClassName={styles.sliderHandle}
					/>
				);
			const playerControls =
				!isPlaying || isActive ? (
					<CSSTransition
						classNames={fadeTransition}
						timeout={{enter: 400, exit: 400}}
					>
						<div className={playerControlsClass} key={"playercontrols"}>
							<RangeSlider
								ref={this.setSeekSliderRef}
								className={styles.seekSlider}
								value={played}
								min={0}
								max={1}
								tooltip={false}
								step={0.01}
								orientation={"horizontal"}
								onChangeStart={this.onSeekMouseDown}
								onChange={this.onSeekChange}
								onChangeComplete={this.onSeekMouseUp}
								handleClassName={styles.sliderHandle}
							/>
							<div className={styles.lowerControlsRow}>
								{playIcon}
								{volumeIcon}
								{volumeSlider}
								<div className={styles.timeDisplay}>
									{this.formatSeconds(elapsed)} / {this.formatSeconds(duration)}
								</div>
								{closedCaptionsIcon}
								<PlaybackSpeedButton
									playbackRate={this.state.playbackRate}
									onPlaybackRateChange={this.onPlaybackRateChange}
								/>
								{fullScreenIcon}
							</div>
						</div>
					</CSSTransition>
				) : null;

			const loadingCircle = isLoaded ? null : (
				<div className={styles.loadingContainer}>
					{" "}
					<LoadingCircle colorType={"white"} />{" "}
				</div>
			);

			let playerAndControlsClass = styles.playerAndControls;
			if (isFullScreen) {
				playerAndControlsClass += ` ${styles.videoFullScreen}`;
			}

			const headerText = this.props.headerText ? (
				<span className={styles.headerText}>{this.props.headerText}</span>
			) : null;

			let containerClass = styles.playerContainer;
			if (this.props.headerText) {
				containerClass += ` ${styles.hasHeaderText}`;
			}

			return this.state.playerErrorCaught ? (
				<ErrorMessage className={styles.crashErrorMessage} />
			) : (
				// Note that when the react player doesn't have a key,
				// switching between videos quickly causes errors in hls.js.
				<div className={containerClass}>
					{wonkyBackground}
					{headerText}
					{loadingCircle}
					<div
						className={playerAndControlsClass}
						onMouseMove={this.onPlayerMouseMove}
						onMouseDown={this.onPlayerMouseDown}
						onMouseUp={this.onPlayerMouseUp}
						ref={r => (this.playerAndControls = r)}
					>
						<div
							className={playerWrapperClass}
							onTouchStart={this.onPlayerWrapperTouchStart}
							onClick={this.onPlayerWrapperClick}
						>
							{bigPlayButton}
							<ReactPlayerWrapper
								defaultRef={this.setPlayerRef}
								key={`video-${this.props.videoIndex}`}
								className={styles.player}
								width="100%"
								height="100%"
								url={this.props.videoURL}
								playing={isPlaying}
								volume={theaterVolume}
								muted={!theaterSoundEnabled}
								playbackRate={this.state.playbackRate}
								onPlay={this.onPlay}
								onPause={this.onPause}
								onProgress={this.onProgress}
								onDuration={this.onDuration}
								onEnded={this.onEnded}
								onError={this.onError}
								onCatchPlayerError={this.onCatchPlayerError}
								progressInterval={100}
							/>
						</div>
						{postVideoEl}
						<TransitionGroup>{playerControls}</TransitionGroup>
					</div>
				</div>
			);
		},
	})
);
